var TimerService = require('services/timer-service');

class PageTimerService {
  constructor(interval = 1000, scale = 1000) {
    this.timer = new TimerService(interval, scale);
  }

  start() {
    this.timer.start();
    return this;
  }

  clear() {
    this.timer.clear();
  }

  save(data) {
    $.post(`/sdk/enrollments/${EF.enrollment.id}/events`, {
      event: {
        name: 'Page Completion Time',
        data: Object.assign({time: this.timer.elapsed}, data)
      }
    }).always(() => {
      this.timer.clear();
    });
  }
}

module.exports = PageTimerService;
